(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["content-grid-custom"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const section = document.getElementById('section-{{ section.id }}');
  if (!section) return;

  const videos = section.querySelectorAll('video[autoplay]');

  if (!('IntersectionObserver' in window)) {
    videos.forEach(function (video) {
      video.setAttribute('playsinline', '');
      video.play().catch(function () {});
    });
    return;
  }

  const videoObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        const video = entry.target;

        if (entry.isIntersecting) {
          if (video.paused) {
            video.play().catch(function () {});
          }
        } else if (!video.paused) {
          video.pause();
        }
      });
    },
    { threshold: 0.25 }
  );

  videos.forEach(function (video) {
    video.setAttribute('playsinline', '');

    if (!video.hasAttribute('controls')) {
      video.muted = true;
    }

    videoObserver.observe(video);
  });
});

  } catch(e) { console.error(e); }
})();
})();
